export const STATION_ERROR_MESSAGES = {
  STATION_CODE_REQUIRED: "Station code is required.",
  STATION_NAME_REQUIRED: "Station name is required.",
  STATION_CODE_EXISTS: "Station code already exists for this store.",
  STATION_NOT_FOUND:
    "Selected station is no longer active or available. Please refresh and try again.",
  STATION_STANDALONE_INACTIVE:
    "Standalone display can only be enabled for active stations.",
  STATION_KDS_DEVICE_REQUIRED:
    "Select the KDS device that should display this station.",
  KDS_DEVICE_NOT_FOUND:
    "The selected KDS is no longer available. Refresh and choose another device.",
  KDS_DEVICE_ALREADY_ASSIGNED:
    "The selected KDS is already assigned to another station.",
  STATION_KDS_DEVICE_ALREADY_ASSIGNED:
    "The selected KDS is already assigned to another station.",
  STATION_KDS_DEVICE_NOT_FOUND:
    "The selected KDS is no longer available. Refresh and choose another device.",
};

export const getStationErrorCode = (error) =>
  error?.data?.code ||
  error?.data?.errorCode ||
  error?.data?.title ||
  error?.data?.error?.title ||
  null;

export const getStationErrorMessage = (
  error,
  fallback = "Something went wrong. Please try again.",
) => {
  const code = getStationErrorCode(error);
  return (
    STATION_ERROR_MESSAGES[code] ||
    error?.data?.detail ||
    error?.data?.message ||
    fallback
  );
};

export const shouldRefreshStations = (error) =>
  getStationErrorCode(error) === "STATION_NOT_FOUND";
